import React from "react";
import {FiX} from "react-icons/fi";

// Shown when the companion flags a risk. Written here, never by the model: the
// numbers must be right every time (patient-journal research, crisis handling).
// Compact and closable: the patient closes it for the day; a new flagged
// message brings it back (features/journal/crisisDismissal.js).
export default function CrisisResources({onDismiss}) {
  return (
    <div
      role="alert"
      className="mb-2 flex items-start gap-3 rounded-lg border border-gray-200 border-l-2 border-l-red-400 bg-white px-3 py-2 text-xs text-slate-700"
    >
      <div className="min-w-0 flex-1">
        <p className="font-medium text-slate-900">Need to talk to someone now?</p>
        <p className="mt-0.5 text-slate-600">
          Call or text <a className="underline" href="tel:988">9-8-8</a>
          {" · "}Kids Help Phone <a className="underline" href="tel:18006686868">1-800-668-6868</a> (text CONNECT to 686868)
          {" · "}Emergency <a className="underline" href="tel:911">911</a>
          {" · "}This journal is not monitored in real time.
        </p>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Close crisis resources"
          className="inline-flex h-6 w-6 flex-none items-center justify-center rounded-md text-slate-400 hover:bg-gray-100 hover:text-slate-600 transition-colors duration-150"
        >
          <FiX className="text-sm" />
        </button>
      )}
    </div>
  );
}
